/* Kuk bilgi sayfaları (sop/politika-blog.json 6, 9, 24, 26-29, 65): konu çiplerinde yumuşak kaydırma ve kaydırdıkça
   seçili çip; soru akordeonunda #soru-... bağlantısıyla gelen soruyu açma ve açılan sorunun adresi; SSS araması;
   iade talebi alt sayfası; iletişim formunda telefon denetimi ve konuya göre yardım satırı. Mesai dışı metni
   assets/kuk-footer.js'teki [data-kuk-mesai] mantığıyla çalışır. JS yoksa çipler düz çapa, sorular details. */
(() => {
  if (window.kukYazi) return;
  window.kukYazi = true;
  const ortak = () => window.kukOrtak || { kaydirma: () => 'smooth', olay: () => {}, altSayfa: { ac: (d) => d.showModal() } };

  // Konu çipleri: dokununca kaydır, kaydırdıkça seçili
  const cipler = () => {
    document.querySelectorAll('[data-konu-cipleri]').forEach((serit) => {
      const baglantilar = [...serit.querySelectorAll('a[href^="#"]')];
      const hedefler = baglantilar.map((a) => document.getElementById(decodeURIComponent(a.hash.slice(1)))).filter(Boolean);
      baglantilar.forEach((a) => a.addEventListener('click', (e) => {
        const h = document.getElementById(decodeURIComponent(a.hash.slice(1)));
        if (!h) return;
        e.preventDefault();
        h.scrollIntoView({ behavior: ortak().kaydirma(), block: 'start' });
        window.history.replaceState(window.history.state, '', a.hash);
      }));
      if (!hedefler.length || !('IntersectionObserver' in window)) return;
      const sec = (id) => baglantilar.forEach((a) => {
        const secili = a.hash.slice(1) === id;
        a.classList.toggle('is-secili', secili);
        if (secili) a.setAttribute('aria-current', 'true'); else a.removeAttribute('aria-current');
      });
      const gozcu = new IntersectionObserver((girdiler) => {
        const gorunen = girdiler.filter((g) => g.isIntersecting).sort((a, b) => a.boundingClientRect.top - b.boundingClientRect.top)[0];
        if (gorunen) sec(gorunen.target.id);
      }, { rootMargin: '-80px 0px -60% 0px' });
      hedefler.forEach((h) => gozcu.observe(h));
    });
  };

  // Sorular: çapayla gelen soru açık; açılan sorunun adresi güncellenir
  const sorular = () => {
    const ac = () => {
      const id = decodeURIComponent(window.location.hash.slice(1));
      const soru = id && document.getElementById(id);
      if (soru && soru.matches('details')) { soru.open = true; soru.scrollIntoView({ block: 'start' }); }
    };
    ac();
    window.addEventListener('hashchange', ac);
    document.addEventListener('toggle', (e) => {
      const d = e.target;
      if (d instanceof HTMLDetailsElement && d.open && d.classList.contains('kuk-soru') && d.id) {
        window.history.replaceState(window.history.state, '', `#${d.id}`);
      }
    }, true);
  };

  // SSS araması: soru ve cevapta, 150 ms gecikmeyle. Sonuçsuz arama olayı yazma durduktan 1,2 sn sonra, aynı terim bir kez
  const arama = () => {
    const kutu = document.querySelector('[data-sss-arama]');
    if (!kutu) return;
    const girdi = kutu.querySelector('input');
    const temizle = kutu.querySelector('[data-sss-temizle]');
    const yok = kutu.querySelector('[data-sss-yok]');
    const yokMetin = kutu.querySelector('[data-sss-yok-metin]');
    const kucuk = (s) => s.toLocaleLowerCase('tr');
    let sayac;
    let olaySayaci;
    let sonTerim = '';
    const uygula = () => {
      clearTimeout(olaySayaci);
      const q = kucuk(girdi.value.trim());
      let toplam = 0;
      document.querySelectorAll('[data-sss-kategori]').forEach((kat) => {
        let n = 0;
        kat.querySelectorAll('.kuk-soru').forEach((s) => {
          const eslesti = !q || kucuk(s.textContent).includes(q);
          s.hidden = !eslesti;
          if (q) s.open = eslesti;
          if (eslesti) n += 1;
        });
        kat.hidden = n === 0;
        const sayi = kat.querySelector('[data-sss-sayi]');
        if (sayi) sayi.textContent = q ? ` (${n})` : '';
        toplam += n;
      });
      temizle.hidden = !q;
      yok.hidden = !q || toplam > 0;
      if (q && toplam === 0) {
        const terim = girdi.value.trim();
        yokMetin.textContent = yokMetin.dataset.kalip.replace('[aranan]', terim);
        olaySayaci = setTimeout(() => {
          if (kucuk(terim) === sonTerim) return;
          sonTerim = kucuk(terim);
          ortak().olay('arama_sonucsuz', { terim, sayfa_tipi: 'sss' });
        }, 1200);
      }
    };
    girdi.addEventListener('input', () => { clearTimeout(sayac); clearTimeout(olaySayaci); sayac = setTimeout(uygula, 150); });
    temizle.addEventListener('click', () => { girdi.value = ''; uygula(); girdi.focus(); });
    kutu.closest('form')?.addEventListener('submit', (e) => { e.preventDefault(); uygula(); });
  };

  // İade talebi alt sayfası
  const iade = () => {
    document.addEventListener('click', (e) => {
      const ac = e.target.closest('[data-iade-talebi-ac]');
      if (!ac) return;
      const dialog = document.querySelector('[data-iade-talebi]');
      if (!dialog) return;
      e.preventDefault();
      ortak().altSayfa.ac(dialog);
    });
    const dialog = document.querySelector('[data-iade-talebi]');
    if (dialog && dialog.querySelector('[data-form-basari]')) ortak().altSayfa.ac(dialog);
  };

  // Formlar: telefon 05 ile başlayan 11 hane, zorunlu alanlar, KVKK onayı; konuya göre yardım satırı
  const formlar = () => {
    document.querySelectorAll('form[data-kuk-form]').forEach((form) => {
      form.noValidate = true;
      form.querySelectorAll('[data-konu-yardim]').forEach((y) => {
        const guncelle = () => { y.hidden = !form.querySelector(`input[name="contact[Konu]"][value="${y.dataset.konuYardim}"]`)?.checked; };
        form.addEventListener('change', guncelle);
        guncelle();
      });
      form.addEventListener('submit', (e) => {
        let ilkHata = null;
        form.querySelectorAll('[data-zorunlu]').forEach((alan) => {
          const kutu = alan.closest('.kuk-alan, fieldset, .kuk-onay');
          let gecerli = alan.type === 'checkbox' ? alan.checked : alan.type === 'radio' ? !!form.querySelector(`input[name="${CSS.escape(alan.name)}"]:checked`) : alan.value.trim() !== '';
          if (gecerli && alan.dataset.telefon !== undefined) gecerli = /^05\d{9}$/.test(alan.value.replace(/\s/g, ''));
          if (gecerli && alan.type === 'email') gecerli = alan.checkValidity();
          const hata = kutu?.querySelector('[data-alan-hata]') || form.querySelector(`[data-alan-hata="${alan.name}"]`);
          if (hata) hata.hidden = gecerli;
          alan.classList.toggle('is-hatali', !gecerli);
          kutu?.classList.toggle('is-hatali', !gecerli && kutu.classList.contains('kuk-onay'));
          if (!gecerli && !ilkHata) ilkHata = alan;
        });
        if (ilkHata) {
          e.preventDefault();
          ilkHata.focus({ preventScroll: true });
          ilkHata.scrollIntoView({ block: 'center', behavior: ortak().kaydirma() });
        }
      });
    });
    const basari = document.querySelector('[data-form-basari]');
    if (basari && !basari.closest('dialog')) basari.scrollIntoView({ block: 'center' });
  };

  // Bölüme atla: bir öğe seçilince kutu kapanır
  const bolumeAtla = () => {
    document.addEventListener('click', (e) => {
      const a = e.target.closest('[data-bolume-atla]');
      if (a) a.closest('details')?.removeAttribute('open');
    });
  };

  const baslat = () => { cipler(); sorular(); arama(); iade(); formlar(); bolumeAtla(); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', baslat);
  else baslat();
})();
